import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import FloatingLines from '../FloatingLines/FloatingLines';
import Particles from '../Particles/Particles';
import Prism from '../Prism/Prism';
import LightPillar from '../LightPillar/LightPillar';
import ColorBends from '../ColorBends/ColorBends';
import { getSidebarBackground } from '../../constants/backgroundSettings';

/**
 * 全站统一背景（除主页面外）：根据用户在设置中的选择显示粒子或线条流动
 */
function SharedPageBackground() {
  const [bgMode, setBgMode] = useState(() => getSidebarBackground());

  useEffect(() => {
    const handler = () => setBgMode(getSidebarBackground());
    window.addEventListener('sidebarBackgroundChanged', handler);
    return () => window.removeEventListener('sidebarBackgroundChanged', handler);
  }, []);

  const renderBackground = () => {
    if (bgMode === 'particles') {
      return (
        <Particles
          particleColors={['#ffffff']}
          particleCount={200}
          particleSpread={10}
          speed={0.1}
          particleBaseSize={100}
          moveParticlesOnHover
          alphaParticles={false}
          disableRotation={false}
          pixelRatio={1}
        />
      );
    }
    if (bgMode === 'prism') {
      return (
        <Prism
          animationType="rotate"
          timeScale={0.5}
          height={3.5}
          baseWidth={5.5}
          scale={3.6}
          hueShift={0}
          colorFrequency={1}
          noise={0}
          glow={1}
        />
      );
    }
    if (bgMode === 'lightPillar') {
      return (
        <LightPillar
          topColor="#5227FF"
          bottomColor="#FF9FFC"
          intensity={1}
          rotationSpeed={0.3}
          glowAmount={0.002}
          pillarWidth={3}
          pillarHeight={0.4}
          noiseIntensity={0.5}
          pillarRotation={25}
          interactive={false}
          mixBlendMode="screen"
          quality="high"
        />
      );
    }
    if (bgMode === 'colorBends') {
      return (
        <ColorBends
          colors={['#ff5c7a', '#8a5cff', '#00ffd1']}
          rotation={0}
          speed={0.2}
          scale={1}
          frequency={1}
          warpStrength={1}
          mouseInfluence={1}
          parallax={0.5}
          noise={0.1}
          transparent
          autoRotate={0}
        />
      );
    }
    return (
      <FloatingLines
        enabledWaves={['top', 'middle', 'bottom']}
        lineCount={4}
        lineDistance={5}
        animationSpeed={0.8}
        interactive={true}
        bendRadius={5}
        bendStrength={-0.5}
        parallax={true}
        parallaxStrength={0.15}
        linesGradient={['#2f4b82', '#667eea', '#764ba2', '#e947f5']}
        mixBlendMode="normal"
      />
    );
  };

  return (
    <>
      <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0, overflow: 'hidden', pointerEvents: 'none' }}>
        {renderBackground()}
      </Box>
      <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0.5, bgcolor: 'rgba(0, 0, 0, 0.55)', pointerEvents: 'none' }} />
    </>
  );
}

export default SharedPageBackground;
